import { useCallback, useEffect, useRef, useState } from 'react';

import generalEndpoints from '../../../../api/services/generalEndpoints';

export const useFetchPolos = () => {
  const [loading, setLoading] = useState();
  const [polos, setPolos] = useState([])
  const isMounted = useRef(true)

  const fetchAllPolos = useCallback(async () => {
    setLoading(true);
    if (polos.length === 0) {
        try {
          const response = await generalEndpoints.getPolos()
          if(response.status === 200) {
            if(isMounted.current) setPolos(response.data)
          }
        } finally {
          setLoading(false);
        }
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    fetchAllPolos().catch(console.error);
    return () => {
      isMounted.current = false;
    };
  }, [fetchAllPolos]);

  return {
    loading,
    polos,
  };
};